<nz-table
  #basicTable
  [nzFrontPagination]="options.showPagination && !options.isLazyLoad"
  [nzPagination]="options.showPagination"
  [nzShowSizeChanger]="options.showPageSizeChanger"
  [nzData]="getPaginationData()"
  [nzBordered]="true"
  [nzSize]="'middle'"
  [class.hide-vertical-border]="hideVerticalBorder"
  [style.--table-border-color]="borderColor"
  [class.hide-top-bottom-lines]="hideTopBottomLines"
  [class.white-header-bg]="whiteHeaderBg"
  [nzTotal]="options?.isLazyLoad ? meta?.totalItems : data.length"
  [nzPageSize]="options?.isLazyLoad ? meta?.pageSize : options.pageSize"
  [nzPageIndex]="options?.isLazyLoad ? meta?.currentPage : pageIndex" 
  [nzTableLayout]="nzTableLayout"
  [nzScroll]="enableHorizontalScroll ? { x: 'max-content' } : {}"
  [nzShowPagination]="options?.showPagination"
  [nzLoading]="isLoading"
  (nzPageIndexChange)="onPageIndexChange($event)"
  (nzPageSizeChange)="onPageSizeChange($event)"
>
  <thead *ngIf="!hideHeaders">
    <tr>
      <!-- Dynamically render the header columns -->
      <th *ngFor="let column of columns" scope="col" [ngStyle]="column.headerStyles" [ngClass]="{'selected-column-header': column.select === true, 'no-border-right': column.noBorderRight === true}" [nzLeft]="column.fixedLeft || false" [nzRight]="column.fixedRight || false" [nzWidth]="column.width ?? null">
        @if(column._config?.displayInColumn) {
        <ng-template
          *ngTemplateOutlet="
            CommonGenericFields;
            context: {
              $implicit: {
                column,
                row: columns,
                isColumn: true,
                columnConfig: column._config
              }
            }
          "
        ></ng-template>
        }
        <ng-container *ngIf="!column._config?.enableFilter">
          <input *ngIf="column.display_name && options?.enableColumnSelection" type="checkbox" class="form-check-input" style="min-width: 13px;" [(ngModel)]="column.select" (change)="onColumnSelectChange($event, column)">
          <!-- {{ column.display_name }} -->
          <div class="d-flex align-items-center justify-content-between">
            <span>{{ column.display_name }}</span>
              <img
                *ngIf="column._config?.headerIcon?.type === 'filter'"
                alt="filter"
                [src]="column._config?.headerIcon?.iconPath || 'assets/images/virtusa-icons/filter.svg'"
                [matTooltip]="column._config?.headerIcon?.tooltip"
                class="header-filter-icon"
                (click)="openColumnFilter($event)"
                (keydown.enter)="openColumnFilter($event)"
              />
          </div>
          <span *ngIf="column.display_name === 'Feedback'" class="ms-2">
            <i
              class="bi bi-info-circle"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="👍Quick approval, no feedback needed. 
              👎 Requires comments—help us refine your test case!"
            >
            </i>
          </span>
          <span *ngIf="column.key === 'totalCount'">
            <mat-icon
              matTooltip="Hover over the total count to see the breakdown."
              matTooltipPosition="above"
              style="cursor: pointer; vertical-align: middle; color: #ffffff"
            >
              info_outline
            </mat-icon>
          </span>
        </ng-container>

        <ng-container
          *ngIf="
            column._config?.enableFilter &&
            column._config?.filter?.type === 'rci'
          "
        >
          <div class="position-relative">
            <span>
              <span> {{ column.display_name }} </span>
              <mat-icon
                (click)="toggleFilterVisibility(column)"
                (keydown)="toggleFilterVisibility(column)"
                style="cursor: pointer; vertical-align: middle; color: #ffffff"
              >
              {{ column.displayFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
              </mat-icon>
            </span>
            <div
              *ngIf="column.displayFilter"
              class="filter-panel-overlay position-absolute p-2"
            >
              <div class="d-flex f-top">
                <span class="flex-grow-1">
                  {{ column._config?.filter?.title }}
                </span>
                <button
                  type="button"
                  class="btn-close"
                  aria-label="Close"
                  (click)="toggleFilterVisibility(column)"
                ></button>
              </div>

              <div class="f-body">
                <div *ngFor="let ind of [1,2,3,4,5]" class="d-flex">
                  <div class="v-center mt-1">
                    <input type="checkbox" class="rci-select" [(ngModel)]="rankSelection[ind]">
                  </div>
                  <app-star-ranker [rank]="ind" [isError]="ind <= 2"></app-star-ranker>
                </div>
              </div>

              <div class="f-footer d-flex justify-content-end mt-2">
                <button class="btn-f btn-accello-secondary mx-1" (click)="resetRciFilter()"> Reset </button>
                <button class="btn-f btn-accello-primary" (click)="applyRciFilter(column)"> Apply </button>
              </div>


            </div>
          </div>
        </ng-container>
      </th>
    </tr>
  </thead>

  <tbody>
    @for (data of basicTable.data; track data) { @for (item of
    mapOfExpandedData[data.id]; track item) { @if ((item.parent &&
    item.parent.expand) || !item.parent) {
    <tr
      *ngIf="!item.hideRow"
      [ngClass]="{
        'highlight-row': item.expand || item.level || item.id === activeRowId,
        'selected-row': item.select === true,
        'sticky-group-row': options.stickyGroupRows && item.expand && item.children?.length
      }"
    >
      <td
        *ngFor="let column of getCols(); let i = index"
        [ngClass]="column.customClass"
        [ngStyle]="column.cellStyles"
        class="dhh"
        [ngClass]="{'selected-column': column.select === true, 'no-border-right': column.noBorderRight === true}"
        [nzShowExpand]="false"
        [(nzExpand)]="item.expand"
        [nzIndentSize]="column.showExpandWithText ? item.level * 20 : 0"
        [nzLeft]="column.fixedLeft || false"
        [nzRight]="column.fixedRight || false"
      >
        @if(options.expandable && item.children && column.showExpandWithText) {
        <div class="d-flex">
          @if(item.expand) {
          <span
            class="material-symbols-outlined cursor-pointer"
            (click)="collapse(mapOfExpandedData[data.id], item, false)"
            (keydown)="collapse(mapOfExpandedData[data.id], item, false)"
          >
            keyboard_arrow_down
          </span>
          } @else {
          <span
            class="material-symbols-outlined cursor-pointer"
            (click)="collapse(mapOfExpandedData[data.id], item, true)"
            (keydown)="collapse(mapOfExpandedData[data.id], item, true)"
          >
            chevron_right
          </span>
          }
          {{ getNestedData(item, column.key) }}
        </div>

        }@else if(options.expandable && item.children && column.showExpand) {
        <div class="d-flex">
          @if(item.expand) {
          <span
            class="material-symbols-outlined cursor-pointer"
            (click)="collapse(mapOfExpandedData[data.id], item, false)"
            (keydown)="collapse(mapOfExpandedData[data.id], item, false)"
          >
            keyboard_arrow_down
          </span>
          } @else {
          <span
            class="material-symbols-outlined cursor-pointer"
            (click)="collapse(mapOfExpandedData[data.id], item, true)"
            (keydown)="collapse(mapOfExpandedData[data.id], item, true)"
          >
            chevron_right
          </span>
          }
        </div>
        } @if(!(item.level && column.hideForChildren) &&
        !(column.hideByLevel?.includes(item.level)) && !column.hidden &&
        !(item.children && column.showExpandWithText) && !column.showExpand) {
        <div
          class="v-center"
          [ngStyle]="{
            'padding-left':
              item.level && column.showExpandWithText ? '12px' : '0'
          }"
        >
          <ng-container>
            @if(column._config || (column._editConfig && item.isRowEditable)) {
            <ng-template
              *ngTemplateOutlet="
                CommonGenericFields;
                context: {
                  $implicit: {
                    column,
                    row: item,
                    isColumn: false,
                    columnConfig:
                      item?.isRowEditable && column._editConfig
                        ? column._editConfig
                        : column._config
                  }
                }
              "
            ></ng-template>
            } @else {
            <ng-container>
              {{ getNestedData(item, column.key) }}
            </ng-container>
            }
          </ng-container>
        </div>
        }
      </td>
    </tr>
    } } }
  </tbody>
</nz-table>

<!-- GENERIC FIELDS -->
<ng-template #CommonGenericFields let-data>
  <label *ngIf="data.columnConfig?.label">
    {{ data.columnConfig?.label }}
  </label>
  <ng-container [ngSwitch]="data.columnConfig?.type">
    <!-- Checkbox column header -->
    <ng-container *ngSwitchCase="'checkbox'">
      @if(data.isColumn) {
      <input
        type="checkbox"
        [checked]="isAllChecked"
        [indeterminate]="isIndeterminate"
        [disabled]="isSelectAllDisabled"
        (change)="onSelectAll($event)"
      />
      } @else {
      <input
        type="checkbox"
        [(ngModel)]="data.row.select"
        (ngModelChange)="onRowSelectChange($event, data.row)"
      />
      }
    </ng-container>

     <ng-container *ngSwitchCase="'image_with_text'">
       <!-- Check if data is an array (for locators) -->
       <ng-container *ngIf="data.row[data.column.key] && data.row[data.column.key].length && data.row[data.column.key][0]?.type; else singleImageText">
         <div class="locators-horizontal-container">
           <div class="locator-item-horizontal" *ngFor="let locator of data.row[data.column.key]">
             <div class="locator-content-horizontal image-with-text">
               <img class="prefix" *ngIf="locator.type" [src]="(data.columnConfig?.prefixImage?.values[locator.type]) | assetUrl" alt="Prefix" />
               <span class="locator-text-horizontal">{{ locator.locator }}</span>
               <img class="suffix" *ngIf="locator.selfHealed" [src]="(data.columnConfig?.suffixImage?.values['true']) | assetUrl" alt="Self healed" />
              </div>
           </div>
         </div>
       </ng-container>
       <!-- Default single image with text -->
       <ng-template #singleImageText>
         <div class="image-with-text">
           <img class="prefix"
             *ngIf="data.row[data.columnConfig?.prefixImage?.targetKey]"
             [src]="(data.columnConfig?.prefixImage?.values[data.row[data.columnConfig?.prefixImage?.targetKey]]) | assetUrl"
             [style]="data.columnConfig?.prefixImage?.styles?.[data.row[data.columnConfig?.prefixImage?.targetKey]]"
             alt="prefix" />
           <span [style]="data.columnConfig?.textStyle">{{ data.row[data.column.key] }}</span>
           <img class="suffix"
             *ngIf="data.row[data.columnConfig?.suffixImage?.targetKey]"
             [src]="(data.columnConfig?.suffixImage?.values[data.row[data.columnConfig?.suffixImage?.targetKey]]) | assetUrl"
             [style]="data.columnConfig?.suffixImage?.styles?.[data.row[data.columnConfig?.suffixImage?.targetKey]]"
             alt="suffix" />
         </div>
       </ng-template>
     </ng-container>

    <!-- Checkbox conditional -->
    <ng-container *ngSwitchCase="'checkbox-conditional'">
      @if((data.columnConfig?.conditionalCheck &&
      data.row[data.columnConfig?.conditionalCheck?.key] ===
      data.columnConfig?.conditionalCheck?.value )) { @if(data.isColumn) {
      <input
        type="checkbox"
        [checked]="isAllChecked"
        [indeterminate]="isIndeterminate"
        (change)="onSelectAll($event)"
      />
      } @else {
      <input
        type="checkbox"
        [(ngModel)]="data.row.select"
        (ngModelChange)="onRowSelectChange($event, data.row)"
      />
      } }
    </ng-container>

    <!-- Link Open-->
    <ng-container *ngSwitchCase="'link'">
      <a
        (click)="emitAction(data.columnConfig?.type, data)"
        class="linkDark"
        [class.link-with-icon]="data.columnConfig?.iconSrc"
      >
        <img *ngIf="data.columnConfig?.iconSrc" class="link-prefix-icon" [src]="(data.columnConfig?.iconSrc) | assetUrl" alt="" />
        {{ data.row[data.column.key] || data.columnConfig?.name }}
      </a>
    </ng-container>

    <!-- Rank -->
    <ng-container *ngSwitchCase="'rank'">
      <app-star-ranker [rank]="data.row[data.column.key]" [isError]="data.row[data.column.key] <= 2"></app-star-ranker>
    </ng-container>

    <ng-container *ngSwitchCase="'double-line-data'">
      <div class="d-flex" >
        <div *ngIf="data.columnConfig?.image && data.row[data.columnConfig?.targetImageKey]" class="v-center mx-2">
          <img class="ignore-common-size double-line-data-img" [src]="(data.columnConfig?.image[data.row[data.columnConfig?.targetImageKey]]) | assetUrl" alt="icon" [style.height]="tableId === 'device_list' ? '24px' : '15px'">
        </div>
        <div class="d-flex flex-column" [style.gap]="(tableId === 'device_list' ? '6px' : (data?.columnConfig?.style?.gap || '0px'))">
          <div>
            <img *ngIf="data.columnConfig?.prefixImage?.isStatic && data.columnConfig?.prefixImage.url" class="ignore-common-size double-line-data-prefix" [src]="(data.columnConfig?.prefixImage.url) | assetUrl" alt="prefix" [ngStyle]="data.columnConfig.prefixImage?.style">
            <strong style="font-weight: 500;">{{ data.row[data.columnConfig.targetKey?.firstLine] }}</strong>
          </div>
          <div>
            <img *ngIf="data.columnConfig?.suffixImage?.isStatic && data.columnConfig?.suffixImage.url" class="ignore-common-size double-line-data-suffix" [src]="(data.columnConfig?.suffixImage.url) | assetUrl" alt="suffix" [ngStyle]="data.columnConfig.suffixImage?.style">
            <span class="double-line-secondary">{{ getSecondLineData(data.row[data.columnConfig.targetKey?.secondLine]) }}</span>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Asset action icon (for example the cluster virtual machine link) -->
    <ng-container *ngSwitchCase="'asset_icon'">
      <span
        *ngIf="showConfiguredIcon(data.columnConfig, data.row)"
        class="action-asset-icon clickable-item"
        role="button"
        tabindex="0"
        [style.--action-icon-url]="'url(' + (data.columnConfig.iconSrc | assetUrl) + ')'"
        [ngStyle]="data.columnConfig.iconStyles"
        [attr.aria-label]="data.columnConfig.tooltip || 'Open'"
        [matTooltip]="data.columnConfig.tooltip"
        (click)="onAssetIconClick($event, data)"
        (keydown.enter)="onAssetIconClick($event, data)"
      ></span>
    </ng-container>

    <!-- Icon -->
    <ng-container *ngSwitchCase="'icon'">
      @if(data.columnConfig?.isCondional) {
      <ng-container
        *ngIf="
          data.columnConfig?.targetKey &&
            data.row[data.columnConfig?.targetKey];
          else noTargetKey
        "
      >
        <div class="d-flex align-items-center">
          <mat-icon
            class="d-flex align-items-center"
            [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
            [ngStyle]="
              data.columnConfig?.value[
                data.row[data.columnConfig?.targetKey].toLowerCase()
              ]?.iconStyles
            "
            (click)="emitAction(data.columnConfig?.type, data)"
            (keydown)="emitAction(data.columnConfig?.type, data)"
          >
            {{
              data.columnConfig?.value[
                data.row[data.columnConfig?.targetKey].toLowerCase()
              ]?.value
            }}
          </mat-icon>
          <span *ngIf="data.columnConfig?.targetKey != 'download_report'"
            >{{ data.row[data.column.key] }}
          </span>
          <!-- DEV NOTE: Below need to be optimized to be dynamic/reusable -->
          <span
            *ngIf="data.columnConfig?.targetKey == 'download_report'"
            class="download"
            (click)="emitAction(data.columnConfig?.type, data)"
            (keydown)="emitAction(data.columnConfig?.type, data)"
          >
            Download Report
          </span>
        </div>
      </ng-container>

      <ng-template #noTargetKey>
        <mat-icon
          [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
          [ngStyle]="
            data.columnConfig?.value[data.row[data.column.key]]?.iconStyles
          "
          (click)="emitAction(data.columnConfig?.type, data)"
          (keydown)="emitAction(data.columnConfig?.type, data)"
        >
          {{ data.columnConfig?.value[data.row[data.column.key]]?.value }}
        </mat-icon>
      </ng-template>

      } @else{
      <div class="d-flex">
        <mat-icon
          (click)="
            emitAction(
              data.columnConfig?.type,
              data,
              'click',
              data.columnConfig?.value
            )
          "
          (keydown)="emitAction(data.columnConfig?.type, data, 'click', data.columnConfig?.value)"
          [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
          [ngStyle]="data.columnConfig?.iconStyles"
        >
          {{ data.columnConfig.value }}
        </mat-icon>
        <div *ngIf="data.column._config?.displayWithText" class="v-center">
          {{ data.row[data.column.key] }}
        </div>
      </div>
      }
    </ng-container>

    <!-- svg -->
    <ng-container *ngSwitchCase="'svg'">
      <img
        (click)="emitAction(data.columnConfig?.type, data)"
        (keydown)="emitAction(data.columnConfig?.type, data)"
        [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
        [src]="(data?.columnConfig?.value) | assetUrl"
        (keydown.enter)="emitAction(data.columnConfig?.type, data)"
        alt="svg"
      />
    </ng-container>

    <!-- row-click -->
    <ng-container *ngSwitchCase="'row-click'">
      <span class="clickable-item" (click)="rowClick(data)" (keydown)="rowClick(data)">
        {{ data.row[data.column.key] }}
      </span>
    </ng-container>

    <!-- date: formats a raw date string using DatePipe -->
    <!-- Usage: column._config = { type: 'date', format: 'MMMM dd, yyyy' } -->
    <ng-container *ngSwitchCase="'date'">
      <span>{{ formatDateCell(data.row[data.column.key], data.columnConfig?.format) }}</span>
    </ng-container>
    <!-- svg-editor -->
    <ng-container *ngSwitchCase="'svg-editor'">
      <img
        (click)="
          emitAction(
            data.columnConfig?.type,
            data,
            '',
            data.columnConfig?.actionType
          )
        "
        (keydown)="emitAction(data.columnConfig?.type, data, '', data.columnConfig?.actionType)"
        [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
        [src]="(data?.columnConfig?.value) | assetUrl"
        (keydown.enter)="emitAction(data.columnConfig?.type, data, '',
            data.columnConfig?.actionType)"
        alt="svg-editor"
      />
    </ng-container>

    <!-- conditional-svg -->
    <ng-container *ngSwitchCase="'conditional-svg'">
      @if((data.columnConfig?.conditionalCheck &&
      data.row[data.columnConfig?.conditionalCheck?.key] ===
      data.columnConfig?.conditionalCheck?.value )) {
      <img
        (click)="emitAction(data.columnConfig?.type, data)"
        (keydown)="emitAction(data.columnConfig?.type, data)"
        [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
        [src]="(data?.columnConfig?.value) | assetUrl"
        (keydown.enter)="emitAction(data.columnConfig?.type, data)"
        alt="conditional-svg"
      />
      }
    </ng-container>

    <!-- Button -->
    <ng-container *ngSwitchCase="'conditional-button'">
      @if((data.columnConfig?.conditionalCheck &&
      data.row[data.columnConfig?.conditionalCheck?.key] ===
      data.columnConfig?.conditionalCheck?.value )) {
      <button
        [ngClass]="
          data.columnConfig.classNames
            ? data.columnConfig.classNames
            : 'ant-btn'
        "
        (click)="emitAction(data.columnConfig?.type, data)"
      >
        <img
          *ngIf="data.columnConfig?.isImage"
          [src]="(data.columnConfig?.imgSrc) | assetUrl"
          class="conditional-img"
          alt="conditional-img"
        />
        {{ data.columnConfig.name }}
      </button>
      }
    </ng-container>

    <ng-container *ngSwitchCase="'button'">
      <button
        [disabled]="data.row?.isDisabled || data.row?.saved"
        [ngClass]="
          data.columnConfig.classNames
            ? data.columnConfig.classNames
            : 'ant-btn'
        "
        (click)="emitAction(data.columnConfig?.type, data)"
      >
        {{ data.row?.saved && data.columnConfig?.savedName ? data.columnConfig.savedName : data.columnConfig.name }}
      </button>
    </ng-container>

    <!-- Input -->
    <ng-container *ngSwitchCase="'input'">
      @if(data.columnConfig?.isAutoCompleteEnable) {
      <app-autocomplete-input
        [options]="autocompleteOptions[data.column.key]"
        [value]="data.row[data.column.key]"
        [placeholder]="data.columnConfig?.placeholder || ''"
        [ngClass]="{'is-invalid': data.row.hasError && data.column.key === 'key'}"
        (optionSelected)="
          onAutoCompleteSelect($event, data.columnConfig?.type, data)
        "
        [isPlain]="true"
      >
      </app-autocomplete-input>
      } @else {
      <input
        class="form-control"
        [class.is-invalid]="data.row.hasError && data.column.key === 'key'"
        [type]="data.columnConfig?.inputType || 'text'"
        [ngClass]="data.columnConfig?.classNames"
        [placeholder]="data.columnConfig?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.columnConfig?.type, data)"
      />
      }
      @if(data.row.hasError && data.column.key === 'key') {
        <div class="invalid-feedback d-block">Key is required.</div>
      }
    </ng-container>

    <!-- Input -->
    <ng-container *ngSwitchCase="'password'">
      <div class="d-flex position-relative">
        <input
          class="form-control"
          [type]="isCellPasswordVisible(data) ? 'text' : 'password'"
          [ngClass]="data.columnConfig?.classNames"
          [placeholder]="data.columnConfig?.placeholder || ''"
          [(ngModel)]="data.row[data.column.key]"
        />
        <span
          cdkDragHandle
          class="material-symbols-outlined eye-visibility"
          (click)="toggleCellPassword(data, $event)"
          (keydown.enter)="toggleCellPassword(data, $event)"
        >
          {{ isCellPasswordVisible(data) ? "visibility_off" : "visibility" }}
        </span>
      </div>
    </ng-container>

    <!-- Select dropdown -->
    <ng-container *ngSwitchCase="'select'">
      <select
        class="form-select"
        [ngClass]="data.columnConfig?.classNames"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.columnConfig?.type, data)"
      >
        <option
          [value]="item.value"
          *ngFor="let item of data.columnConfig?.options"
        >
          {{ item.label }}
        </option>
      </select>
    </ng-container>

    <!-- Multi-Select dropdown -->
    <ng-container *ngSwitchCase="'multi-select'">
      <nz-select
        class="custom-select"
        [nzMode]="data.columnConfig?.isMulti ? 'multiple' : 'default'"
        [(ngModel)]="data.row[data.column.key]"
        (ngModelChange)="emitAction(data.columnConfig?.type, data)"
        [nzMaxTagCount]="50"
        [nzShowArrow]="true"
        [nzDropdownStyle]="{ 'max-height': '200px', overflow: 'auto' }"
        [nzDropdownMatchSelectWidth]="false"
        nzTooltipPlacement="top"
        [nzPlaceHolder]="data.columnConfig?.placeholder"
      >
        <nz-option
          *ngFor="let option of (data.columnConfig?.optionsKey ? data.row[data.columnConfig.optionsKey] : data.columnConfig?.options)"
          [nzLabel]="option.label"
          [nzValue]="option.value"
        >
        </nz-option>
      </nz-select>
    </ng-container>

    <!-- Browser image-only dropdown -->
    <ng-container *ngSwitchCase="'browser-select'">
      <div class="browser-custom-select" (click)="toggleBrowserDropdown(data.row.id, $event)" (keydown.enter)="toggleBrowserDropdown(data.row.id, $event)">
        <div class="browser-trigger">
          <img *ngIf="data.row[data.column.key]" [src]="(data.columnConfig?.imageMap?.[data.row[data.column.key]] || '') | assetUrl" [alt]="data.row[data.column.key]" class="browser-icon-sel" />
          <span *ngIf="!data.row[data.column.key]" class="browser-placeholder">Browser</span>
        </div>
        <div class="browser-panel" *ngIf="browserDropdownOpen[data.row.id]">
          <div *ngFor="let opt of data.row[data.columnConfig?.optionsKey || 'browserOptions']"
               class="browser-panel-opt"
               [class.active]="data.row[data.column.key] === opt"
               (click)="selectBrowserOption(data.row, data.column.key, opt, $event)"
               (keydown.enter)="selectBrowserOption(data.row, data.column.key, opt, $event)"
            >
            <img [src]="(data.columnConfig?.imageMap?.[opt] || '') | assetUrl" [alt]="opt" class="browser-icon-opt" />
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Textarea -->
    <ng-container *ngSwitchCase="'textarea'">
      <textarea
        class="form-control"
        [ngClass]="data.columnConfig?.classNames"
        [placeholder]="data.columnConfig?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.columnConfig?.type, data, $event)"
        (blur)="emitAction(data.columnConfig?.type, data, $event, 'blur')"
      >
      </textarea>
    </ng-container>

    <!-- Feedback with thubms up/down -->
    <ng-container *ngSwitchCase="'thumb-feedback'">
      <div class="d-flex flex-row">
        <mat-icon
          *ngFor="let icon of data.columnConfig?.value; let i = index"
          (click)="emitAction(data.columnConfig?.type, data, i)"
          (keydown)="emitAction(data.columnConfig?.type, data, i)"
          [ngClass]="{
            'clickable-item': data.columnConfig?.isClickable,
            clicked: data.row.iconClicked === i
          }"
          [ngStyle]="data.columnConfig?.iconStyles"
        >
          {{ icon }}
        </mat-icon>
      </div>
      <textarea
        *ngIf="data.row.feedbackEnabled === true"
        class="form-control"
        [ngClass]="data.columnConfig?.classNames"
        [placeholder]="data.columnConfig?.placeholder || ''"
        [(ngModel)]="data.row[data.column.key]"
        (change)="emitAction(data.columnConfig?.type, data, $event)"
        (blur)="emitAction(data.columnConfig?.type, data, $event, 'blur')"
      >
      </textarea>
    </ng-container>

    <!-- Context menu -->
    <ng-container *ngSwitchCase="'contextMenu'">
      <mat-icon
        class="clickable-item"
        [ngStyle]="data.columnConfig?.iconStyles"
        [matMenuTriggerFor]="contextMenu"
      >
        {{ data.columnConfig.icon }}
      </mat-icon>
      <mat-menu #contextMenu="matMenu">
        <button
          (click)="
            emitAction(
              data.columnConfig?.type,
              data,
              $event,
              'click',
              menu.value
            )
          "
          [hidden]="menu.hideOnEdit && data.row.isRowEditable"
          mat-menu-item
          *ngFor="let menu of data.columnConfig?.options"
        >
        <img *ngIf="menu.image"
          [src]="(menu.image) | assetUrl"
          [alt]=""
          [ngStyle]="menu.imageStyle"
        />
          <span>{{ menu.label }}</span>
        </button>
      </mat-menu>
    </ng-container>

     <!-- Context menu conditional -->
     <ng-container *ngSwitchCase="'contextMenu-conditional'">
      @if((data.columnConfig?.conditionalCheck &&
      data.row[data.columnConfig?.conditionalCheck?.key] ===
      data.columnConfig?.conditionalCheck?.value )) {
      <mat-icon
        class="clickable-item"
        [ngStyle]="data.columnConfig?.iconStyles"
        [matMenuTriggerFor]="contextMenu"
      >
        {{ data.columnConfig.icon }}
      </mat-icon>
      <mat-menu #contextMenu="matMenu" class="custom-context-menu">
        <button
          (click)="
            emitAction(
              data.columnConfig?.type,
              data,
              $event,
              'click',
              menu.value
            )
          "
          [hidden]="menu.hideOnEdit && data.row.isRowEditable"
          mat-menu-item
          *ngFor="let menu of data.columnConfig?.options"
        >
        <img *ngIf="menu.image"
          [src]="(menu.image) | assetUrl"
          [alt]=""
          [ngStyle]="menu.imageStyle"
        />
          <span>{{ menu.label }}</span>
        </button>
      </mat-menu>
      }
    </ng-container>

    <!-- Context menu - data populates by row expansion level -->
    <ng-container *ngSwitchCase="'contextMenuByLevel'">
      <mat-icon
        class="clickable-item"
        [ngStyle]="data.columnConfig?.iconStyles"
        [matMenuTriggerFor]="contextMenuByLevelMenu"
      >
        {{ data.columnConfig.icon }}
      </mat-icon>
      <mat-menu #contextMenuByLevelMenu="matMenu">
        <button
          (click)="
            emitAction(
              data.columnConfig?.type,
              data,
              $event,
              'click',
              menu.value
            )
          "
          mat-menu-item
          *ngFor="let menu of data.columnConfig?.options[data.row.level]"
        >
          {{ menu.label }}
        </button>
      </mat-menu>
    </ng-container>

    <!-- Image -->
    <ng-container *ngSwitchCase="'image'">
      @if(data.columnConfig?.isConditional) {
      <div>
        <img
          *ngIf="data.columnConfig?.value[data.row[data.columnConfig?.targetKey]]?.value"
          [src]="
            (data.columnConfig?.value[data.row[data.columnConfig?.targetKey]]
              ?.value) | assetUrl
          "
          [alt]="data.row[data.columnConfig?.targetKey]"
          [ngStyle]="
            data.columnConfig?.value[data.row[data.columnConfig?.targetKey]]
              ?.style
          "
        />
      </div>
      }
    </ng-container>

    <!-- copy_id -->
    <ng-container *ngSwitchCase="'copy_id'">
      <div>{{ data.row[data.column.key] }}</div>
      <div class="copy-div">
        <span>
          {{ data.row[data.columnConfig?.key] }}
        </span>
        <mat-icon
          (click)="emitAction(data.columnConfig?.type, data)"
          [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
          (keydown.enter)="emitAction(data.columnConfig?.type, data)"
        >
          {{ data.columnConfig?.value }}
        </mat-icon>
        <mat-icon
          [matTooltip]="data.columnConfig?.tooltip"
          matTooltipPosition="above"
          [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
        >
          {{ data.columnConfig?.tooltipIcon }}
        </mat-icon>
      </div>
    </ng-container>

    <!-- custom_tooltip -->
    <ng-container *ngSwitchCase="'custom_tooltip'" class="custom-tooltip">
      <div>
        <span
          [nzTooltipTitle]="tooltipTemplate"
          nzTooltipTrigger="hover"
          nzTooltipPlacement="top"
          nz-tooltip
          nzTooltipClass="custom-zorro-tooltip"
          [nzTooltipColor]="color"
          [ngClass]="{ 'clickable-item': data.columnConfig?.isClickable }"
          [ngStyle]="{
            color: data.columnConfig?.isClickable ? '#2f76ff' : 'inherit'
          }"
        >
          {{ data.row[data.column.key] }}
        </span>

        <ng-template #tooltipTemplate>
          <div class="status-tooltip-content">
            <div class="status-row header">
              <div *ngFor="let item of data.columnConfig.mappingData">
                {{ item.display_name }}
              </div>
            </div>
            <div class="status-row">
              <div
                *ngFor="let item of data.columnConfig.mappingData"
                [ngStyle]="{ width: item.headerStyles?.width }"
              >
                {{ data.row[item.key] }}
              </div>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-container>

    <!-- Lozenge -->
    <ng-container *ngSwitchCase="'lozenge'">
      <span
        *ngIf="data.row[data.column.key]"
        [ngClass]="data.columnConfig.classMapping?.[data.row[data.column.key]]"
        [ngStyle]="data.columnConfig.style"
      >
        <span class="circle-dot"></span>
        {{ data.row[data.column.key] }}
      </span>
    </ng-container>

        <!-- request-type -->
    <ng-container *ngSwitchCase="'request-type'">
      <span
        *ngIf="data.row[data.column.key]"
        [ngClass]="data.columnConfig.classMapping?.[data.row[data.column.key]]"
        [ngStyle]="data.columnConfig.style"
      >
        {{ data.row[data.column.key] }}
      </span>
    </ng-container>

    <!-- Severity Badge -->
    <ng-container *ngSwitchCase="'severity-badge'">
      <span
        *ngIf="data.row[data.column.key]"
        [ngClass]="data.columnConfig.classMapping?.[data.row[data.column.key]]"
        [ngStyle]="data.columnConfig.style"
      >
        {{ data.row[data.column.key] }}
      </span>
    </ng-container>

    <!-- Lozenge-status -->
    <ng-container *ngSwitchCase="'lozenge_status'">
      <div class="lozenge-status-cell">
        <div
          *ngIf="data.row[data.column.key]"
          class="badge general-text-5 custom-badge-status badge-secondary"
          [ngClass]="data.columnConfig.classMapping?.[data.row[data.column.key]]"
          [ngStyle]="data.columnConfig.style"
        >
          {{ data.row[data.column.key] }}
          <span
            *ngIf="
              data.row[data.column.key] == 'EXECUTING' ||
              data.row[data.column.key] == 'WAITING'
            "
            class="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        </div>
        <!-- Optional suffix action icon (e.g. log icon shown only for Crashed) -->
        <img
          *ngIf="data.columnConfig?.suffixActionIcon &&
                 data.row[data.columnConfig.suffixActionIcon.conditionalKey] === data.columnConfig.suffixActionIcon.condition"
          [src]="data.columnConfig.suffixActionIcon.iconSrc | assetUrl"
          class="lozenge-suffix-icon clickable-item"
          alt="action"
          (click)="emitAction(data.columnConfig.suffixActionIcon.actionType, data)"
          (keydown.enter)="emitAction(data.columnConfig.suffixActionIcon.actionType, data)"
        />
      </div>
    </ng-container>

    <!-- Title with Description -->
    <ng-container *ngSwitchCase="'title_with_description'">
      <div class="title-with-desc">
        <span class="title-text">{{ data.row[data.column.key] }}</span>
        <span
          *ngIf="data.columnConfig?.subtitleKey && data.row[data.columnConfig?.subtitleKey]"
          class="desc-text"
          [ngClass]="data.columnConfig?.subtitleClassNames"
        >
          <img
            *ngIf="data.columnConfig?.subtitleIconMap && data.columnConfig.subtitleIconMap[data.row[data.columnConfig?.subtitleKey]]"
            [src]="data.columnConfig.subtitleIconMap[data.row[data.columnConfig?.subtitleKey]] | assetUrl"
            class="subtitle-icon"
            alt=""
          />
          {{ data.row[data.columnConfig?.subtitleKey] }}
        </span>
      </div>
    </ng-container>

    <!-- Inline Split Text: bold primary value + dash + muted secondary value on one line -->
    <!-- Usage: _config = { type: 'inline-split-text', subtitleKey: 'provider', separator: '-' } -->
    <ng-container *ngSwitchCase="'inline-split-text'">
      <div>
      <span class="inline-split-primary">{{ data.row[data.column.key] }}</span>
      <ng-container *ngIf="data.columnConfig?.subtitleKey && data.row[data.columnConfig?.subtitleKey]">
        <span class="inline-split-separator">{{ data.columnConfig?.separator || '-' }}</span>
        <span class="inline-split-secondary">{{ data.row[data.columnConfig?.subtitleKey] }}</span>
      </ng-container>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'readable_dt'">
      <div class="v-center">
        <span> {{ getReadableDt(data.row[data.column.key]) }} </span>
      </div>
    </ng-container>

    <!-- Version Badge Dropdown: shows current active version + expandable version history tree -->
    <ng-container *ngSwitchCase="'version-badge'">
      <app-version-badge-dropdown [data]="data.row[data.column.key]"></app-version-badge-dropdown>
    </ng-container>

    <!-- Menu Dropdown -->
    <ng-container *ngSwitchCase="'menu_dropdown'">
      <app-menu-dropdown
        [selectedValue]="data.row[data.columnConfig?.targetKey]"
        [placeholderText]="data.row.placeholderText"
        [data]="
          data.columnConfig.targetOptions
            ? data.row[data.columnConfig.targetOptions]
            : data.columnConfig.componentInputs?.fields
        "
        (onSelect)="
          emitAction(data.columnConfig?.type, data, $event, '', $event)
        "
      >
      </app-menu-dropdown>
    </ng-container>

    <!-- Section Dropdown -->
    <ng-container *ngSwitchCase="'section_dropdown'">
      <app-dropdown-with-sections
        [selectedValue]="data.row[data.columnConfig?.targetKey]"
        [config]="data.columnConfig.componentInputs?.config"
        [fields]="
          data.columnConfig.targetOptions
            ? data.row[data.columnConfig.targetOptions]
            : data.columnConfig.componentInputs?.fields
        "
        (onSelect)="
          emitAction(data.columnConfig?.type, data, $event, '', $event)
        "
      >
      </app-dropdown-with-sections>
    </ng-container>

    <!-- Grouped fields -->
    <ng-container *ngSwitchCase="'group'">
      <div class="row">
        <ng-container *ngFor="let field of data.columnConfig?.fields">
          <div
            [ngClass]="
              getGroupClassName(data.columnConfig?.fields, field.wrapperClass)
            "
          >
            <label *ngIf="field.label"> {{ field.label }} </label>
            <ng-container [ngSwitch]="field.type">
              <!-- Input -->
              <ng-container *ngSwitchCase="'input'">
                <input
                  class="form-control"
                  [type]="field.inputType || 'text'"
                  [ngClass]="field.classNames"
                  [placeholder]="field.placeholder || ''"
                  [(ngModel)]="field.value"
                  (change)="emitAction(field.type, data)"
                />
              </ng-container>

              <!-- Select dropdown -->
              <ng-container *ngSwitchCase="'select'">
                <select
                  class="form-select"
                  [ngClass]="field.classNames"
                  [(ngModel)]="field.value"
                  (change)="emitAction(field.type, data)"
                >
                  <option
                    [value]="item.value"
                    *ngFor="let item of field.options"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </ng-container>

              <!-- Image -->
              <ng-container *ngSwitchCase="'image'">
                @if(field.isConditional) {
                <div>
                  <img
                    [src]="(field.value[data.row[field.targetKey]]?.value) | assetUrl"
                    [alt]="field.value[data.row[field.targetKey]]?.value"
                    [ngStyle]="field.value[data.row[field.targetKey]]?.style"
                  />
                </div>
                }
              </ng-container>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>
</ng-template>
